<template>
    <div>
       <FilterFolder v-on:getAll="$emit('getAll')" @updateTable="updateTable" v-on:SearchItems="SearchItemss" :selectedComissao="selectedComissao" :title="'Filtro de Vendas'" v-if="flFilterFolder"></FilterFolder>
       <Forms v-if="!flFilterFolder"  ref="frmPermission"
            :title="title"
            :showHelp="true"
            :showClearButtonIcon="true"
            :ShowFooterImbo="true"
            :showSearchIcon="true"
            :showSearchButtonIcon="true"
            v-on:Clear="Clear"
            v-on:Search="Search"
            v-on:Load ="onLoad"
          >
          <div>
              <div id="form-search">
              <label class="labelseach">Corretor</label>
              <autocomplete-z ref="CommissionTypeahead"
                          placeholder="Digite um corretor"
                          iconClass="fas fa-user"
                          :serializer="(corretor) => corretor.nome"
                          :debounceLength="2"
                          :formField="SearchItems.corretor"
                          v-on:search="onSearchComission"
                          v-on:changeCode="onChangeCodeComission"
                          :ShowCode="false"
                           />
              <label class="labelseach mt-3">Empreendimento</label>
                <select v-model="SearchItems.empreendimentoId" class="form-control" id="exampleFormControlSelect2">
                  <option disabled selected :value="''">Selecione um empreendimento</option>
                  <option v-for="data in consultaenterprise" v-bind:key="data.id" :value="data.id">{{data.nome}}</option>
                </select>

               <label class="labelseach mt-3">Forma de Pagamento</label>
                <select v-model="SearchItems.formaPagament" name="selectPagamento" class="form-control" id="selectPagamento">
                    <option disabled selected :value="''">Selecione uma forma de pagamento</option>
                    <option v-for="data in consultapagamento" v-bind:key="data.nome" :value="data.nome">{{data.nome}}</option>
                </select>
              <label class="labelseach mt-3" for="txtInsured">Data Da Venda</label>
              <p class="labelseach-ate">Desde</p>
              <div class="d-flex align-items-end">
                <b-form-datepicker
                v-model ="SearchItems.DataInicio"
                  placeholder="__/__/__"
                  locale="pt-BR"
                  today-button
                  label-today-button="Hoje"
                  reset-button
                  label-reset-button="Limpar"
                  close-button
                  label-close-button="Fechar"
                  :date-format-options="{ year: '2-digit', month: 'numeric', day: 'numeric' }"
                  ></b-form-datepicker>
              </div>
              <p class="labelseach-ate">Até</p>
              <div class="d-flex align-items-end">
                  <b-form-datepicker
                  v-model ="SearchItems.DataFinal"
                  placeholder="__/__/__"
                  locale="pt-BR"
                  today-button
                  label-today-button="Hoje"
                  reset-button
                  label-reset-button="Limpar"
                  close-button
                  label-close-button="Fechar"
                  :date-format-options="{ year: '2-digit', month: 'numeric', day: 'numeric' }"
                  ></b-form-datepicker>
              </div>
            </div>
          </div>
    </Forms>
    </div>
</template>

<script>

import formSales from './formSales'
export default formSales

</script>

<style scoped>
.margem{
  margin-bottom: 31%;
}
.names-folder{
  font-size: 15px;
  width: 90%;
  height: 35px;
  padding: 10px;
  cursor: pointer;
  font-weight: bold;
  border-radius: 7px;
  cursor: pointer;

}
.names-folder-active{
  font-size: 15px;
  width: 90%;
  color: #008148;
  background-color: #E9ECEF;
  height: 35px;
  padding: 10px;
  cursor: pointer;
  font-weight: bold;
  border-radius: 7px;
  cursor: pointer;
}
.labelseach{
    font-weight: 700;
    color: #666;
    font-size: 14px;
    margin-bottom: 5px;
    padding-bottom: 0;
    font-family: Segoe UI;
}
.labelseach-ate {
    margin-top: 10px;
    font-weight: 700;
    color: #666;
    font-size: 14px;
    margin-bottom: 5px;
    padding-bottom: 0;
    font-family: Segoe UI;
}
</style>



// WEBPACK FOOTER //
// src/views/private/realestate/salesinquiry/components/formSales/formSales.vue